.ft{z-index:2;}